export const SET_ACTIVE_ACCOUNT_INFO = 'SET_ACTIVE_ACCOUNT_INFO';
export const SET_USER = 'SET_USER';
export const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS';
export const SET_FEATURES = 'SET_FEATURES';
export const SET_IM_USER = 'SET_IM_USER';
export const ADD_ACCOUNT_NAME = 'ADD_ACCOUNT_NAME';
export const SET_CADENCE_ACCOUNTS = 'SET_CADENCE_ACCOUNTS';
export const REMOVE_ACCOUNT_NAME = 'REMOVE_ACCOUNT_NAME';
export const SET_CUSTOMER_ALERT_BOX = 'SET_CUSTOMER_ALERT_BOX';
export const SET_PRODUCT_TEASER = 'SET_PRODUCT_TEASER';
export const SET_CLIENT_IP = 'SET_CLIENT_IP';
export const SET_LOADING_ACCOUNTS = 'SET_LOADING_ACCOUNTS';
export const SET_AIRSHIP_CHANNEL_ID = 'SET_AIRSHIP_CHANNEL_ID';
export const SET_DEVICE_ID = 'SET_DEVICE_ID';
export const SET_IS_SIDE_NAVIGATION_COLLAPSED = 'SET_IS_SIDE_NAVIGATION_COLLAPSED';
